/* ---------------------------------------------- /*
/* Load more buttons */
/* ---------------------------------------------- */
const send_url = "/load/";
const load_button = document.getElementById('btn-load-more');
const load_info = document.getElementById('load_info');
const load_wrap = document.getElementById('load_wrap');
const filter_langs = document.querySelectorAll('.lang-filter-item');
const limit = 30;
const XHR = new XMLHttpRequest();

var langChanged = false;

/* send, request toggles and delete */
window.addEventListener("load", () => {

  function initLoad(langChanged) {

    var total_arts, load_offset, load_type, load_cats='', load_langs='';
    var response_json, data;

    // get data info
    total_arts = load_info.dataset.count;
    load_offset = load_info.dataset.offset;
    load_type = load_info.dataset.type;
    if (load_type == 'categories' || load_type == 'author' || load_type == 'tag') {
      load_cats = load_info.dataset.cats;
    }

    // active languages
    if (filter_langs) {
      filter_langs.forEach(function (lang) {
        if (lang.classList.contains('active')) {
          if (load_langs.length > 0) {
            load_langs += ',';
          }
          load_langs += lang.dataset.lang;
        }
      })
    };

    // lang has changed? - todo - new total lang articles, add lang optin essays!
    if (langChanged === true) {
      // reset offset to 0
      load_offset = 0;
      load_wrap.innerHTML = '';
    }

    total_arts = parseInt(total_arts);
    load_offset = parseInt(load_offset);

    // response
    XHR.onreadystatechange = function () {
      if (XHR.readyState === 4) {
        // add new html
        var dataHtml = XHR.response;
        var childrenLength;
        
        //length children + total items span
        load_wrap.innerHTML += dataHtml;
        childrenLength = load_wrap.children.length;

        // ausgabe total filter, show, hide button
        if (total_arts > 0 && childrenLength > 0) {
            // show, hide button
            if (childrenLength > total_arts) {
              load_button.classList.add('d-none');
            } else {
              new_offset = load_offset+limit;
              load_info.setAttribute('data-offset', new_offset);
            }
        }
      }
    };

    // Define what happens in case of error
    XHR.addEventListener("error", (event) => {
      alert('Daten konnten nicht übermittelt werden.');
    });

    // Set up our request
    XHR.open("POST", send_url, true);
    XHR.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    XHR.send('type='+load_type+'&total='+total_arts+'&offset='+load_offset+'&cats='+load_cats+'&langs='+load_langs);
  }

  // delete entry
  if (load_button) {
    load_button.addEventListener("click", (e) => {
      langChanged = false;
      // send
      initLoad(langChanged);
    });
  }

  // filter - filtered output
  if (filter_langs) {
    filter_langs.forEach(function (lang) {
      lang.addEventListener("click", () => {
        langChanged = true;
        if (lang.classList.contains('active')) {
          lang.classList.remove("active");
        } else {
          lang.classList.add("active");
        }
        // load langs
        initLoad(langChanged);

      })
    })
  }
});
